import Message from 'antd/lib/message'
import 'antd/lib/message/style'

import './message.less'

export * from 'antd/lib/message'

export default Message
